import { a, useTransition } from "@react-spring/web";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Background = styled.div`
  position: fixed;
  inset: 0;
  background: black;
  /* Above drawer (10000), below modals content (>=11001) */
  z-index: 11000;
`;
const BackgroundWrapper = ({ stack, closeModal }) => {
  const [backgroundOpacity, setBackgroundOpacity] = useState(0);
  const [pointerEvents, setPointerEvents] = useState("none");
  useEffect(() => {
    setPointerEvents(stack.length > 0 ? "auto" : "none");
  }, [stack.length]);

  const backgroundTransition = useTransition(stack.length, {
    from: { opacity: 0 },
    leave: { opacity: 0 },
    enter: { opacity: 0.5 },
    update: { opacity: backgroundOpacity || 0.5 },
  });

  return backgroundTransition((style, item) => {
    return item ? (
      <a.div
        style={{ ...style, pointerEvents }}
        onClick={() => {
          const top = stack?.[stack?.length - 1];
          const opts = top?.options || {};
          if (!opts?.preventClose) {
            if (typeof opts?.onClose === "function") {
              try {
                opts.onClose();
              } catch {}
            }
            closeModal();
          }
        }}
      >
        <Background />
      </a.div>
    ) : null;
  });
};
export default BackgroundWrapper;
